namespace Gamification.Gamification {
    export interface UtentiDelegatiConProprietaForm {
        UserId: Serenity.IntegerEditor;
        UserIdDelDelegato: Serenity.IntegerEditor;
        AdminDisplayName: Serenity.StringEditor;
        Cognome: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        RagioneSociale: Serenity.StringEditor;
    }

    export class UtentiDelegatiConProprietaForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiDelegatiConProprieta';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiDelegatiConProprietaForm.init)  {
                UtentiDelegatiConProprietaForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(UtentiDelegatiConProprietaForm, [
                    'UserId', w0,
                    'UserIdDelDelegato', w0,
                    'AdminDisplayName', w1,
                    'Cognome', w1,
                    'Nome', w1,
                    'Email', w1,
                    'RagioneSociale', w1
                ]);
            }
        }
    }
}
